import pulse from '@finn-no/pulse-sdk';

export function trackSavedSearchClick() {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Create',
        name: 'Saved search',
        object: {
            id: 'save-search-click',
            type: 'UIElement',
            elementType: 'Button',
        },
    });
}

export function trackSavedSearchComplete(
    searchId: number,
    isNewSearch: boolean,
) {
    pulse.trackEvent({
        type: 'Click',
        intent: isNewSearch ? 'Save' : 'Edit',
        name: 'Saved search',
        object: {
            id: 'save-search-complete',
            type: 'UIElement',
            elementType: 'Button',
        },
        target: {
            id: `savedsearch:${searchId}`,
            type: 'SavedList',
            name: 'saved search',
        },
    });
}
